import axios from 'axios'
import { clog } from './functions'

const getUserToken = () => {
  if (typeof Android != "undefined") {
    var token = Android.getUserToken();
    return token
  }
}

export const APIPost = async (endUrl = '', headers = {}, params = {}, body = {}, isAndroidWebview = false, isTokenPresent = false) => {
  axios.defaults.withCredentials = true
  if (process.env.NEXT_PUBLIC_APP_ENV === 'local' && isTokenPresent)
    headers['Authorization'] = 'Token 87320b97930cc341e0acc6aa97d40f3b95836ba2'
  if (isAndroidWebview)
    headers['Authorization'] = getUserToken()
  const config = {
    method: 'post',
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + endUrl,
    headers,
    params,
    data: body
  }
  const response = await axios(config).catch((error) => clog(error))
  return response?.data
}

export const APIPatch = async (endUrl = '', headers = {}, params = {}, body = {}, isAndroidWebview = false) => {
  axios.defaults.withCredentials = true
  if (isAndroidWebview)
    headers['Authorization'] = getUserToken()
  const config = {
    method: 'patch',
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + endUrl,
    headers,
    params,
    data: body
  }
  const response = await axios(config).catch((error) => clog(error))
  return response?.data
}

export const APIGet = async (endUrl = '', headers = {}, params = {}, isAndroidWebview = false) => {
  axios.defaults.withCredentials = true
  if (isAndroidWebview) headers['Authorization'] = getUserToken()
  const config = {
    method: 'get',
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + endUrl,
    params,
    headers
  }
  const response = await axios(config).catch((error) => clog(error))
  return response?.data
}

export const APIDelete = async (
  endUrl = '',
  headers = {},
  params = {},
  isAndroidWebview = false
) => {
  axios.defaults.withCredentials = true
  if (isAndroidWebview) headers['Authorization'] = getUserToken()
  const config = {
    method: 'delete',
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + endUrl,
    headers,
    params
  }
  const response = await axios(config).catch((error) => clog(error))
  return response?.data
}
